import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import FeedbackImpactVisualization from './FeedbackImpactVisualization';

const FeedbackImpactModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-gray-50 rounded-3xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        {/* 헤더 */}
        <div className="flex items-center justify-between p-6 bg-white border-b border-gray-100">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">피드백 영향력 대시보드</h2>
            <p className="text-gray-600">여러분의 의견이 만드는 실제 변화를 확인해보세요</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
            title="닫기"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        {/* 콘텐츠 */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          <FeedbackImpactVisualization />
        </div>
      </div>
    </div>
  );
};

export default FeedbackImpactModal;